import { WhitelabelConstants } from '../constants';
import { WhitelabelService } from '../../services/';
import { alertActions } from './';
import { whitelabel } from '../reducers/whitelabel.reducer';
import Swal from 'sweetalert2';
import { history } from '../../helpers';
import { constants } from '../../Constants';

export const WhitelabelActions = {
	fetchWhitelabel,
	setWhitelabel,
	selectWhitelabel,
	resetWhitelabel,
};

function fetchWhitelabel() {
	return (dispatch) => {
		dispatch(request());

		WhitelabelService.fetchWhitelabel().then(
			(whitelabel) => {
				dispatch(success(whitelabel));
			},
			(error) => dispatch(failure(error.toString()))
		);
	};
}

function setWhitelabel(data, id = '') {
	return (dispatch) => {
		dispatch({type: WhitelabelConstants.CREATEWHITELABEL_REQUEST})
		WhitelabelService.setWhitelabel(data, id).then(
			(whitelabel) => {
				Swal.fire({
					title: constants.SAAYA_HEALTH_TXT,
					text: id === '' ? constants.SUCCESS_PROJECT_CREATED : constants.SUCCESS_PROJECT_UPDATED,
					icon: constants.SUCCESS_TEXT,
					confirmButtonText: constants.OK_TXT
				});
				if (id !== '') resetWhitelabel();
				history.replace('/home');
			},
			(error) => {
				dispatch({type: WhitelabelConstants.CREATEWHITELABEL_FAILURE})
				const errorMessage = error.response.data.message || constants.GENERAL_ERROR_TXT;
				Swal.fire({
					title: constants.SAAYA_HEALTH_TXT,
					text: errorMessage,
					icon: constants.ERROR_TEXT,
					confirmButtonText: constants.OK_TXT
				});
				if (error && error.response && error.response.data) {
					let errors = error.response.data;
					let possible_errors = [
						'username',
						'password1',
						'password2',
						'non_field_errors',
						'email_address',
						'error',
						'0',
					];
					for (var key in errors) {
						if (possible_errors.includes(key)) {
							dispatch({ type: WhitelabelConstants.CREATEWHITELABEL_FAILURE, message: errors[key] });
						}
					}
				} 
				// else if (error && error.response && error.response.data) {
				// 	let errors = error.response.data ?
				// 	error.response.data : error.response.data.error ? error.response.data.error : {message: 
				// 	'The Porject cannot be added at the moment'};
					
				// 	dispatch({ type: WhitelabelConstants.CREATEWHITELABEL_FAILURE, message: errors.message });
				// }
				//dispatch(failure(error.toString()))
			}
		);
	};
}

function request() {
	return { type: WhitelabelConstants.GETWHITELABEL_REQUEST };
}

function success(whitelabel) {
	if (whitelabel.length > 0) {
		
		return { type: WhitelabelConstants.GETWHITELABEL_SUCCESS, whitelabel };
	} else {
		const whitelabel = []; //whitelabelObj;
		return { type: WhitelabelConstants.GETWHITELABEL_FAILURE, whitelabel };
	}
}

function failure(error) {
	return { type: WhitelabelConstants.GETWHITELABEL_FAILURE, error };
}

function selectWhitelabel(id) {
	return (dispatch) => {
		dispatch({ type: WhitelabelConstants.SELECTED_WHITELABEL, id });
	};
}

function resetWhitelabel() {
	return (dispatch) => {
		dispatch({ type: WhitelabelConstants.RESET_WHITELABEL });
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/whitelabel.actions.js